import useSWR from "swr"
import { PickingShortageApi } from "../../../apis"

export function useShortagesByPullSheetQuery(pullSheetId: string | null | undefined) {
  return useSWR(
    pullSheetId ? ["pull-sheet-shortages", pullSheetId] : null,
    async () => PickingShortageApi.listShortages(pullSheetId as string),
    { revalidateOnFocus: false },
  )
}
